export const NoProjectView = () => {
  return (
    <div className='not_found'>
      <h2>Project not found! (404)</h2>
    </div>
  )
}
